import { Component, OnInit, TemplateRef } from '@angular/core';
import { ValidationService } from '../../shared/providers/validation.service'
import { AuthenticationService } from '../../shared/auth/authentication.service'
import { PropertyListingService } from '../../shared/providers/property-listing.service'
import { LoaderService } from '../../shared/providers/loader.service'
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { UserManagerService } from '../../shared/providers/user-manager.service'
import { Router, ActivatedRoute, Params } from '@angular/router';
import * as Highcharts from 'highcharts';
import { AnalyticsService } from '../../shared/providers/analytics.service';
import { IPropertyDetails } from '../../shared/models/propertydetails';
import { SharedService } from '../../shared/providers/shared.service';
import { IMessageInput } from '../../shared/models/MessageInputModel';
import { CommonService } from '../../shared/providers/common.service';
import { IPropertyChatModel } from '../../shared/models/PropertyChatModel';
import { DocAccessStatus } from '../../shared/enum/enum';

if (typeof Highcharts === 'object') {

  let Boost = require('highcharts/modules/boost');
  let noData = require('highcharts/modules/no-data-to-display');
  let More = require('highcharts/highcharts-more');

  Boost(Highcharts);
  noData(Highcharts);
  More(Highcharts);
  noData(Highcharts);
}

interface ISellerInfo {
  Id: number;
  FirstName: string;
  LastName: string;
  Email: string;
  Phone: string;
  Company: string;
}

enum Tabs {
  MarketData = 1,
  PropertyMarketing = 2,
  CreditProfile = 3,
  PropertyDetails = 4,
  AssetManagement = 5,
  DueDelligence = 6,
  PropertyHistory = 7,
  Message = 8
}

@Component({
  selector: 'app-property-details',
  templateUrl: './property-details.component.html',
  styleUrls: ['./property-details.component.css']
})
export class PropertyDetailsComponent implements OnInit {
  currentMenu = '';

  constructor(private router: Router, private activatedRoute: ActivatedRoute, private Analytics: AnalyticsService,
    private UserManager: UserManagerService, public Validation: ValidationService, private modalService: BsModalService, private propertyListing: PropertyListingService, public authentication: AuthenticationService, private Loader: LoaderService, private Shared: SharedService, public _commonService: CommonService) {
    this.activatedRoute.queryParams.subscribe((params: Params) => {
      if (params['detailstab'] !== undefined && params['detailstab'] !== null && params['detailstab'] !== '') {
        this.currentTab = params['detailstab'];
      }
      if (params['opentab'] !== undefined && params['opentab'] !== null && params['opentab'] !== '') {
        this.myPortfolioTab = params['opentab'];
      }
      if (params['prevroute'] !== undefined && params['prevroute'] !== null && params['prevroute'] !== '') {
        this.prevPage = params['prevroute'];
      }
      if (params['link'] !== undefined && params['link'] !== null && params['link'] !== '') {
        this.prevPageRouteLink = params['link'];
      }
      let fromMenu = params['fromMenu'];
      if (fromMenu !== null && fromMenu !== undefined) {
        this.currentMenu = fromMenu;
      }
      if (params['iscreated'] !== undefined && params['iscreated'] !== null && params['iscreated'] !== '') {
        this.iscreated = params['iscreated'];
      }
       if (params['UserGuid'] != null && params['UserGuid'] != '' && params['UserGuid'] != undefined) {
        this.UserGuid = params['UserGuid'];
        localStorage.setItem('principalGuid', this.UserGuid);
      }
    });
  }
  modalRefBOV: BsModalRef;
  modalRef: BsModalRef;
  user: any;
  individualHighlightData = [] as any;
  properties: any[];
  sellerId: any;
  sellerGuid = null;
  propertyGuid = null;
  propertyChatModel = {} as IPropertyChatModel;
  property = {} as IPropertyDetails;
  Isshowgraph: number = 0;
  sellerInfo = {} as ISellerInfo;
  marketDataChart = [] as any;
  tabs = Tabs;
  currentTab = Tabs.MarketData;
  myPortfolioTab = 0;
  prevPage = 'My Properties';
  UserGuid: string;
  prevPageRouteLink = '/market-snapshot';
  iscreated: any;
  tenantName = null;
  docAccessStatus = DocAccessStatus;
  canEditProperty: boolean = true;
  isDataEntryProperty: boolean;
  minimumValue: number = 0;
  messageInput = {} as IMessageInput;
  graphText: string;
  isDashboardEnabled: boolean = false;
  actualproperty = {} as IPropertyDetails;

  public chartOptions: any = {}
  IsChartLoaded: number = 0;

  ngOnInit() {
    this.Loader.display(true);
    const id = this.activatedRoute.snapshot.params.id || '';
    this.propertyGuid = id;
    this.activatedRoute.queryParams.subscribe(params => {
      if (params['detailstab'] == undefined || params['detailstab'] == null || params['detailstab'] == '') {
        if (this.authentication.Principal() || this.authentication.Principal1031) {
          this.currentTab = Tabs.MarketData;
        }
        else {
          this.currentTab = Tabs.PropertyDetails;
        }
      }
    });


    let loggedUserDetails = (JSON.parse(localStorage.getItem('currentUser')));
    this.user = loggedUserDetails;


    if (this.iscreated == '1') {
      this.isDataEntryProperty = true;
      this.propertyListing.getDataEntryPropertyDetails(this.propertyGuid, this.user.Id).subscribe(response => {
        if (response != null) {
          this.property = response;
          if (this.property.LivePropertyGuid != null && this.property.LivePropertyGuid != '' && this.property.LivePropertyGuid != '00000000-0000-0000-0000-000000000000') {
            this.propertyListing.getPropertyDetails(this.property.LivePropertyGuid, this.user.Id, false, true).subscribe(response => {
              if (response != null) {
                this.isDashboardEnabled = true;
                this.actualproperty = response;
              }
            });
          }
        }
      });
    }
    else {
      this.isDataEntryProperty = false;
      this.propertyListing.getDataEntryPropertyDetails(this.propertyGuid, this.user.Id).subscribe(response => {
        if (response != null) {
          this.property = response;
          if (this.property.LivePropertyGuid != null && this.property.LivePropertyGuid != '' && this.property.LivePropertyGuid != '00000000-0000-0000-0000-000000000000') {
            this.propertyListing.getPropertyDetails(this.property.LivePropertyGuid, this.user.Id, false, true).subscribe(response => {
              if (response != null) {
                this.isDashboardEnabled = true;
                this.actualproperty = response;
              }
            });
          }
        }
      });
    }

    this.loadChart();
  }

  openBOVRequestModal(template: TemplateRef<any>, classes: any) {
    this.modalRefBOV = this.modalService.show(template, { class: classes });
  }
  onTabClick(tab) {
    this.currentTab = tab;
    let url = this.router.url.split('?')[0];
    url = this.Validation.updateQueryStringParameter(this.router.url, 'detailstab', tab)
    if (localStorage.getItem('currentFileRefreshTab') != undefined && localStorage.getItem('currentFileRefreshTab') != null) {
      localStorage.removeItem('currentFileRefreshTab');
    }
    this.router.navigateByUrl(url);
  }

  loadChart() {

    let tenantChart = [];
    let Xaxis = [];
    let tenantChartAssetType = [];
    let tenantChartSubcategory = [];

    let chart1Name = "";
    let chart2Name = "";
    let chart3Name = "";
    const that = this;
    this.Analytics.GetAvgCapRateChartDetail(this.propertyGuid).subscribe(response => {
      ////this.tenantChart = response;
      console.log(response);

      if (response != null && response.length > 0) {
        this.graphText = response[1].Name;
        response.forEach(function (dataset, i) {
          chart1Name = dataset.Name;
          //// this.graphText = dataset.Name;
          Xaxis.push(dataset.XAxis + '-' + dataset.Year);
          tenantChart.push(dataset.AvgCapRate);

        });
      }

      if (chart1Name != null && chart1Name != '' && chart1Name != undefined) {
        this.Isshowgraph = 1
        let newchartdata1 = {
          name: chart1Name,
          data: tenantChart,
          //  color: this.getChartColors(1)
          color: '#02C29F',
          marker: {
            "symbol": "circle"
          }
        };
        if (tenantChart != null && tenantChart != undefined && tenantChart.length > 0) {
          this.minimumValue = tenantChart.reduce((a, b) => Math.min(a, b));
        }
        this.marketDataChart.push(newchartdata1)
      }
      console.log(Xaxis);
      console.log(tenantChart);

      this.Analytics.GetAvgCapRateChartDetailForAssetType(this.propertyGuid).subscribe(response1 => {
        ////let data1 = response1;
        if (response1 != null && response1.length > 0) {
          response1.forEach(function (dataset, i) {
            chart2Name = dataset.Name;
            tenantChartAssetType.push(dataset.AvgCapRate);

          });
        }
        if (chart2Name != null && chart2Name != '' && chart2Name != undefined) {
          this.Isshowgraph = 1
          let newchartdata1 = {
            name: chart2Name,
            data: tenantChartAssetType.map(i => i),
            /*color: this.getChartColors(0)*/
            color: '#198FDE',
            marker: {
              "symbol": "circle"
            }
          };
          this.marketDataChart.push(newchartdata1);
          if (tenantChartAssetType != null && tenantChartAssetType != undefined && tenantChartAssetType.length > 0) {
            let newminimumValue = tenantChartAssetType.reduce((a, b) => Math.min(a, b));
            this.minimumValue = (newminimumValue != null && newminimumValue != undefined) ? newminimumValue < this.minimumValue ? newminimumValue : this.minimumValue : this.minimumValue;
          }
        }
        this.Analytics.GetAvgCapRateChartDetailForSubCategoryType(this.propertyGuid).subscribe(response2 => {
          //// let data2 = response2;
          if (response2 != null && response2.length > 0) {
            response2.forEach(function (dataset, i) {
              chart3Name = dataset.Name;
              tenantChartSubcategory.push(dataset.AvgCapRate);

            });
          }
          if (chart3Name != null && chart3Name != '' && chart3Name != undefined) {
            this.Isshowgraph = 1
            let newchartdata1 = {
              name: chart3Name,
              data: tenantChartSubcategory.map(i => i),
              //  color: this.getChartColors(2)
              color: '#FFC32B',
              marker: {
                "symbol": "circle"
              }
            };
            if (tenantChartSubcategory != null && tenantChartSubcategory != undefined && tenantChartSubcategory.length > 0) {
              let newminimumValue = tenantChartSubcategory.reduce((a, b) => Math.min(a, b));
              this.minimumValue =  (newminimumValue != null && newminimumValue != undefined) ? newminimumValue < this.minimumValue ? newminimumValue : this.minimumValue : this.minimumValue;
            }
            this.marketDataChart.push(newchartdata1)
          }
          this.minimumValue = this.minimumValue > 1 ? (this.minimumValue) : this.minimumValue;
          if (this.Isshowgraph == 1) {
            this.chartOptions = {
              chart: {
                type: 'spline',
                height: 400
              },
              title: {
                text: ''
              },
              subtitle: {
                text: ''
              },
              yAxis: {
                gridLineWidth: 0,
                minorGridLineWidth: 0,
                tickInterval: 0.5,
                min: this.minimumValue,
                title: {
                  text: ''
                },
                labels: {
                  format: '{value}%'
                },
                allowDecimals: true,
              },
              xAxis: {
                categories: Xaxis,
                crosshair: true
              },

              plotOptions: {
                column: {
                  pointPadding: 0.2,
                  borderWidth: 0
                }
              },
              credits: {
                enabled: false
              },
              tooltip: {
                headerFormat: '<span style="font-size:13px"><b>{point.key} - {point.series.name}</b></span><table>',
                pointFormatter: function () {
                  var point = this;
                  return '<tr><td padding:0"> Avg Cap Rate : </td><td style="padding:0"><b>' + point.y + ' %</b></td></tr>';
                },
                footerFormat: '</table>',
                shared: false,
                useHTML: true,
                shadow: false,
                floating: true,

              },
              series: this.marketDataChart,
              responsive: {
                rules: [{
                  condition: {
                    maxWidth: 500
                  },
                  chartOptions: {
                    legend: {
                      layout: 'horizontal',
                      align: 'center',
                      verticalAlign: 'bottom'
                    }
                  }
                }]
              }

            }
            that.getIndividualHighlight();
            Highcharts.chart('BarRemainingTermCapRate', this.chartOptions);
            this.IsChartLoaded = 1;
          }
        });
      });
    });
  }

  onHomeBreadCrumbClick() {
    this.router.navigateByUrl('/principal-dashboard');
  }

  onBreadCrumbClick() {
    if (this.prevPageRouteLink = '/market-snapshot') {
      let tabNumber = this.prevPage != undefined && this.prevPage != null && this.prevPage != '' ? this.prevPage == "My Properties" ? 2 : this.prevPage == "Market Snapshot" ?1:1 : 1;
      this.prevPageRouteLink = '/market-snapshot?UserGuid=' + this.UserGuid + '&opentab=' + tabNumber;
    }
    this.router.navigateByUrl(this.prevPageRouteLink);
  }

  getChartColors(index) {
    const colors = ['#198FDE', '#02C29F', '#003A5D'];
    return colors[index];
  }

  getIndividualHighlight() {
    this.individualHighlightData = [] as any;
    if (this.marketDataChart != null && this.marketDataChart != undefined && this.marketDataChart.length > 0) {
      this.marketDataChart.forEach(s => {
        if (s != null) {
          let currentValue = 0;
          let previousValue = 0;
          let difference = 0;
          let TypeData = {} as any;
          currentValue = s.data[11];
          previousValue = s.data[10];
          let informationText = '';
          let rating = currentValue.toFixed(2);
          if (currentValue >= previousValue) {
            difference = currentValue - previousValue;
            let differenceText = difference.toFixed(2);
            if (difference > 0) {
              difference = parseFloat(difference.toFixed(2));
              informationText = 'The average asking cap rate has increased by ' + differenceText + ' % from the previous month.';
              TypeData = { name: s.name, currentValue: currentValue, difference: difference, StatusId: 1, InfoText: informationText }
            }
            else {
              informationText = 'The average asking cap rate has not changed from the previous month.';
              TypeData = { name: s.name, currentValue: currentValue, difference: difference, StatusId: 0, InfoText: informationText}
            }
          }
          else {
            difference = previousValue - currentValue;
            if (difference > 0) {
              let differenceText = difference.toFixed(2);
              difference = parseFloat(difference.toFixed(2))
              informationText = 'The average asking cap rate has decreased by ' + differenceText + ' % from the previous month.';
            }
            TypeData = { name: s.name, currentValue: currentValue, difference: difference, StatusId: 2, InfoText: informationText}

          }
          this.individualHighlightData.push(TypeData);
        }
      })
    }
  }
  openMessageTab(template: TemplateRef<any>, classes, Property) {
    var openModelStatus = true;
    if (openModelStatus) {
      if (this.property.LivePropertyGuid != "") {
        let i = 0;
        if (i == 0) {
          this.propertyChatModel.ExchangeId = 0;
          this.propertyChatModel.PropertyGuid = this.property.LivePropertyGuid;
          this.Shared.clickMessage(this.propertyChatModel);
        }
        else {
          this.propertyChatModel.ExchangeId = 0;
          this.propertyChatModel.PropertyGuid = this.property.LivePropertyGuid;
          this.Shared.clickMessage(this.propertyChatModel);
        }

      }
    }
  }
}
